export default __webpack_public_path__ + "static/media/ketoparties@2x.672700f0.jpg";